<template>
  <div>
    <form-file
      label="معرض الصور"
      accept="image/*"
      id="form-slide"
      placeholder="اختر صور"
      name="image"
      @change="onImagesChanged"
      multiple
    />
    <div
      class="d-flex justify-content-between shadow align-items-center my-1"
      v-for="(item, i) in imagesPreview"
      :key="i"
    >
      <b-img
        :src="item.url"
        fluid-grow
        style="width: 50px !important; height: 50px"
        class="m-1 rounded"
      />
      <span>
        {{ item.name.length > 30 ? `${item.name.slice(0, 30)}...` : item.name }}
      </span>
      <b-button
        @click="deleteImage(i)"
        variant="flat-danger"
        class="btn-icon rounded-circle"
      >
        <feather-icon size="15" icon="Trash2Icon" />
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BImg } from "bootstrap-vue";
import FormFile from "@/components/form-file/index.vue";
export default {
  components: {
    FormFile,
    BButton,
    BImg,
  },
  props: {
    value: {
      default: () => [],
    },
  },
  data() {
    return {
      imagesPreview: [],
    };
  },
  computed: {
    images: {
      set(val) {
        this.$emit("input", val);
        this.imagesPreview = Array.from(val).map((file) => ({
          url: URL.createObjectURL(file),
          name: file.name,
        }));
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    onImagesChanged(event) {
      this.images = event.target.files;
    },
  },
};
</script>
